<template>
    <div>
        <content-header v-bind:title="$t(ftitle)"></content-header>
        <loading v-bind:dspin="!contentLoaded"></loading>

        <div class="w3-container w3-margin-top flow-main-content w3-center" v-if="contentLoaded">

            <div class="w3-margin-bottom">
                <i class="fa fa-user-md w3-margin-right w3-xlarge flow-blue-color"></i>
                <span class="w3-margin-right font-weight-bold"> {{$t("chooseDoctor")}} </span>
                <flow-select :items="physicians"
                             :valueKey="'nameAgendaID'"
                             :valueKeyIndex="'id'"
                             :callback="showReport"
                             :preSelectedItem="selectedPhysician"
                             class="zero-top w3-show-inline-block w-50pc">
                </flow-select>
            </div>


            <loading v-bind:dspin="!showAvgChart"></loading>

            <div v-if="showAvgChart" id="chart" class="flow-card blue-top w3-animate-opacity"
                 style="min-height: 200px;">
                <div style="padding:2vw 6vw 0 6vw">

                    <div v-if="!chartData.data || chartData.data.length === 0">
                        <h4 class="w3-margin w3-center">
                            {{ $t('noData') }}
                        </h4>
                    </div>

                    <div v-else>
                        <flow-line-chart :canvas-id="'avgWaitChart'" :data="chartData.data"
                                         :xlabels="chartData.xlabels" :chartHeading="$t('avgChartLegend')"></flow-line-chart>
                        <canvas id="avgWaitChart" class="w3-padding w3-center"></canvas>
                    </div>

                </div>
            </div>

        </div>
    </div>

</template>
<script>
    import Vue from 'vue';
    import ContentHeader from "../components/common/ContentHeader";
    import Loading from "../components/common/Loading";
    import FlowSelect from "../components/common/FlowSelect";
    import FlowLineChart from "../components/chart/FlowLineChart";
    import {EventBus} from "../main";

    let frc = Vue.prototype.$frc;

    export default {
        name: "DataAnalytics",
        components: {FlowLineChart, Loading, ContentHeader, FlowSelect},
        props: ['ftitle'],
        data: function () {
            return {
                contentLoaded: false,
                showAvgChart: false,
                physicians: [],
                selectedPhysician: {},
                title: "",
                chartData: {
                    data: undefined,
                    xlabels: undefined
                },
                monthMap: {
                    '1': 'jan',
                    '2': 'feb',
                    '3': 'mar',
                    '4': 'apr',
                    '5': 'may',
                    '6': 'jun',
                    '7': 'jul',
                    '8': 'aug',
                    '9': 'sep',
                    '10': 'oct',
                    '11': 'nov',
                    '12': 'dec'
                }
            }
        },
        mounted() {
            this.getAllPhysicians();
            var user = Vue.prototype.$currentUser.user;
            this.selectedPhysician = user.physician;
            if (user.physician) {
                this.selectedPhysician.nameAgendaID = user.physician.name + "(" + user.physician.agendaSystemIds[0] + ")";
            }
            EventBus.$on("menuToggled", this.repaintChart);
        },
        beforeDestroy() {
            EventBus.$off("menuToggled", this.repaintChart);
        },
        methods: {
            repaintChart() {
                this.getAvgWaitData(this.selectedPhysician);
            },
            showReport(physician) {
                this.selectedPhysician = physician;
                this.getAvgWaitData(physician);
            },
            getAllPhysicians() {
                const app = this;
                frc.getAllPhysicians().then(function (res) {
                    var physicians = res.data;
                    for (var i = 0; i < physicians.length; i++) {
                        var nameID = physicians[i].name + "(" + physicians[i].agendaSystemIds[0] + ")";
                        physicians[i].nameAgendaID = nameID;
                    }
                    app.physicians = physicians;
                    Vue.sortByKey(app.physicians, 'name');
                    app.contentLoaded = true;
                }).catch(function (ex) {
                    console.log(ex);
                })
            },
            getAvgWaitData(phy) {
                this.showAvgChart = false;
                if (!phy) {
                    this.chartData = {
                        data: [],
                        xlabels: []
                    };
                    return;
                }

                var avgs = [];
                var app = this;
                frc.getAverageWaitingForPhysician(phy.id).then(function (res) {
                    avgs = res.data;
                    app.setAvgWaitData(avgs);
                    app.showAvgChart = true;
                }).catch(function (ex) {
                    avgs = [];
                    console.log(ex);
                    app.showAvgChart = true;
                });

            },
            setAvgWaitData(raw) {
                raw.sort(function (a, b) {
                    var ma = parseInt(a.month);
                    var mb = parseInt(b.month);

                    var ya = parseInt(a.year);
                    var yb = parseInt(b.year);

                    if (ya === yb) {
                        if (ma > mb) return 1;
                        else return -1;
                    }

                    if (ya > yb) {
                        return 1;
                    }

                    return -1;
                });


                var app = this;
                var xaxis = [];
                var avgs = [];

                raw.forEach(function (r) {
                    var im = parseInt(r.month);
                    var iy = parseInt(r.year);

                    r.label = app.$t('months')[app.monthMap[im]] + " " + iy;
                    r.waitInMins = Math.round(r.averageWaitInSeconds / 60);
                    xaxis.push(r.label);
                    avgs.push(r.waitInMins);
                });

                this.chartData.data = avgs;
                this.chartData.xlabels = xaxis;
            },
        }
    }

</script>

<style scoped>

</style>